import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectedMapFilterSelector, setSelectedMapFilter } from './mapSlice';
import { SelectedMapFilter } from './utilts';

export const useSelectedMapFilter = () => {
  const dispatch = useDispatch();
  const selectedMapFilter = useSelector(selectedMapFilterSelector);

  const onSelectMapFilter = React.useCallback((selected: SelectedMapFilter) => {
    dispatch(setSelectedMapFilter(selected));
  }, [dispatch]);

  return {
    selectedMapFilter,
    onSelectMapFilter,
  };
};
